export { default } from './AgeRangesEditor';
export * from './AgeRangesEditor';
